if (!customElements.get('a3-addon-picker')) {
  customElements.define(
    'a3-addon-picker',
    class A3AddonPicker extends HTMLElement {
      connectedCallback() {
        this.selects = Array.from(this.querySelectorAll('[data-a3-addon-select]'));
        this.totalRow = this.querySelector('.a3-addon-picker__total');
        this.totalAmount = this.querySelector('[data-a3-addon-total]');
        this.basePrice = parseInt(this.dataset.basePrice, 10) || 0;
        this.form = document.getElementById(this.dataset.formId);
        this.moneyFormatter = new Intl.NumberFormat(this.dataset.locale || undefined, {
          style: 'currency',
          currency: this.dataset.currency || 'USD',
        });

        this.onFormData = this.onFormData.bind(this);
        this.form?.addEventListener('formdata', this.onFormData);
        this.selects.forEach((select) => {
          select.addEventListener('change', () => {
            this.updatePreview(select);
            this.updateTotal();
          });
          this.updatePreview(select);
        });

        if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
            if (data.sectionId !== this.dataset.sectionId || !data.variant) return;
            this.basePrice = data.variant.price;
            this.updateTotal();
          });
        }
      }

      disconnectedCallback() {
        this.form?.removeEventListener('formdata', this.onFormData);
        this.variantChangeUnsubscriber?.();
      }

      get selectedOptions() {
        return this.selects
          .map((select) => select.selectedOptions[0])
          .filter((option) => option && option.value);
      }

      // Fires while product-form.js builds its FormData: fold the main
      // variant and every picked add-on into one items[] payload so a single
      // /cart/add request creates separate line items. Add-on quantity
      // mirrors the main quantity (BC modifiers price per unit).
      onFormData(event) {
        const picks = this.selectedOptions;
        if (!picks.length) return;

        const formData = event.formData;
        const mainId = formData.get('id');
        if (!mainId) return;
        const quantity = parseInt(formData.get('quantity'), 10) || 1;

        formData.delete('id');
        formData.delete('quantity');
        const ids = [mainId, ...picks.map((option) => option.value)];
        ids.forEach((id) => {
          formData.append('items[][id]', id);
          formData.append('items[][quantity]', quantity);
        });
      }

      // Photo of the picked add-on (a3i.attached_image, else its product
      // image) in the preview row under this group's select; "None" or an
      // option without an image hides the row. display:none, so nothing
      // shifts while the row is hidden.
      updatePreview(select) {
        const preview = select.closest('.a3-addon-picker__group')?.querySelector('[data-a3-addon-preview]');
        if (!preview) return;
        const option = select.selectedOptions[0];
        const src = option?.value ? option.dataset.image : '';
        if (!src) {
          preview.hidden = true;
          return;
        }
        const img = preview.querySelector('img');
        if (img.getAttribute('src') !== src) {
          img.src = src;
          img.alt = option.dataset.imageAlt || option.dataset.title || '';
        }
        preview.querySelector('[data-a3-addon-preview-title]').textContent = option.dataset.title || '';
        preview.querySelector('[data-a3-addon-preview-note]').textContent = option.dataset.attached
          ? 'Shown installed on a compatible host'
          : '';
        preview.hidden = false;
      }

      updateTotal() {
        const picks = this.selectedOptions;
        this.totalRow.hidden = picks.length === 0;
        if (!picks.length) return;
        const total = picks.reduce(
          (sum, option) => sum + (parseInt(option.dataset.price, 10) || 0),
          this.basePrice
        );
        this.totalAmount.textContent = this.moneyFormatter.format(total / 100);
      }
    }
  );
}
